import * as React from "react";
import { Menu } from "antd";
import Link from "./Link";
import { IOrganisation } from "../../../organisations/model/Organisation";
import SubMenu from "antd/lib/menu/SubMenu";
import { MenuOutlined } from "@ant-design/icons";

const OrganisationOperatorLayoutMenu = ({
  router,
  translate,
  userOrganisation
}: {
  router: any;
  translate;
  userOrganisation?: IOrganisation;
}) => (
  <Menu
    mode="horizontal"
    className={"header-menu-primary"}
    overflowedIndicator={<MenuOutlined />}
  >
    <Menu.Item key="menu:case_law_document">
      <Link router={router} path="/search?collection=STAV&q=">
        {translate("editors.case_law_documents.case_law_document")}
      </Link>
    </Menu.Item>

    {userOrganisation?.id && (
      <Menu.Item key="menu:organisation">
        <Link router={router} path={`/organisation/${userOrganisation?.id}`}>
          {translate("pages.settings")}
        </Link>
      </Menu.Item>
    )}
    <SubMenu
      key="sub:reports"
      title={
        <span>
          <span className={"header-menu-item-label"}>
            {translate("menu.reports")}
          </span>
        </span>
      }
    >
      <Menu.Item>
        <Link router={router} path="/index-harmonization-report">
          {translate("reports.non_harmonised_index_data_report")}
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link router={router} path="/indexes-by-category-data-report">
          {translate("reports.indexes_by_category_data_report")}
        </Link>
      </Menu.Item>
    </SubMenu>
  </Menu>
);

export default OrganisationOperatorLayoutMenu;
